import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Bonuses() {
  return <section className="w-full bg-navy-deep px-3 py-14 sm:px-6 sm:py-20" data-id="element-123" data-mp="1hifyl84wyudv">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="1clftp0jsvxoc">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-125" data-mp="18jun1wxv0fml">Ma non è tutto…</p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-126" data-mp="25a3kfbnbjf9a">
          Oggi riceverai anche 5 bonus esclusivi
        </h2>
        <p className="mx-auto mt-4 max-w-xl px-1 text-center text-[15px] leading-relaxed text-white/70" data-id="element-127" data-mp="1w95cwjdo8ply">
          Non sono semplici extra aggiunti a caso: sono strumenti pratici progettati per rendere il Sistema più veloce e
          più facile da applicare nella tua pratica quotidiana.
        </p>

        <div className="mt-9 space-y-5" data-id="element-128" data-mp="fv6udgas6nz0">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-3xl bg-white/[0.06] ring-1 ring-white/10" data-id="element-129" data-mp="fx9vowhdw3j1">
              <div className="bg-white px-1 pb-1 pt-1" data-id="element-130" data-mp="1jrghf175u5n2">
                <img src={bonus.image} alt={`Mockup del ${bonus.label}: ${bonus.title}`} className="w-full" width={1240} height={1240} loading="lazy" data-id="element-131" data-mp="15t8or5h5pqhp" />
              </div>

              <div className="p-4 sm:p-6" data-id="element-132" data-mp="10tvqzpoqyz0c">
                <div className="flex items-center gap-2.5" data-id="element-133" data-mp="10uno54xzt4sq">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand/20" data-id="element-134" data-mp="n2r0bd3cxh25">
                    <GiftIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-135" data-mp="r3sydqljfn2j" />
                  </span>
                  <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-136" data-mp="d3roxmr7j7bg">
                    {bonus.label}
                  </span>
                </div>

                <h3 className="mt-3 font-display text-[20px] font-bold leading-snug text-white sm:text-[22px]" data-id="element-137" data-mp="2jsjywr541xmm">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-[13.5px] font-semibold text-brand" data-id="element-138" data-mp="2f0k39aw2pqvu">{bonus.subtitle}</p>
                <p className="mt-3 text-[14px] leading-relaxed text-white/70" data-id="element-139" data-mp="2b0hzmw6s2ndx">{bonus.body}</p>

                <div className="flex flex-wrap items-center gap-2 pt-5" data-id="element-140" data-mp="262q4zuer0n61">
                  <span className="rounded-full bg-white/10 px-3 py-1.5 text-[12px] font-semibold text-white/80" data-id="element-141" data-mp="32qefbq8kjbf1">
                    Valore: <span className="line-through" data-id="element-142" data-mp="2yqcd9fyx8fz8">{bonus.value}</span>
                  </span>
                  <span className="rounded-full bg-brand px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-143" data-mp="2tp6hf99ysclh">
                    Incluso gratis oggi
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-7 text-center text-[14px] text-white/70" data-id="element-144" data-mp="1dbq1rlo8rnff">
          Tutti i bonus sono inclusi oggi senza costi aggiuntivi.
        </p>

        <CtaBlock className="mt-6" label="Richiedi ora i 5 bonus" tone="dark" data-id="element-145" data-mp="136q4dcp0xjy4" />
      </div>
    </section>;
}